<template>
  <div
    v-if="data?.posts?.length"
    class="py-12 space-y-12"
  >
    <TContainer
      v-if="tag"
      size="sm"
      class="space-y-2 text-center"
    >
      <TMarketingPreTitle>
        {{ t('pages.blog.blogCategory') }}
      </TMarketingPreTitle>

      <THeadingMarketing :level="3">
        {{ tag.name }}
      </THeadingMarketing>

      <p class="text-lg text-gray-500">
        {{ tag.description }}
      </p>
    </TContainer>

    <GridBlogList :post-list="data?.posts" />

    <GhostPagination
      :pagination="data?.meta?.pagination"
      :is-disabled="pending"
    />
  </div>
</template>

<script setup lang="ts">
const route = useRoute()
const { t, locale } = useI18n()
const setI18nParams = useSetI18nParams()
const { getPosts } = useGhostApi()

definePageMeta({
  i18n: {
    paths: {
      en: '/category/[slug]',
      fr: '/categorie/[slug]',
    },
  },
})

const page = computed(() => (route.query.page ? Number(route.query.page) : 1))

const { data, error, pending } = await useAsyncData(
  computed(() => `blog-category-${route.params.slug}-${locale.value}-${page.value}`),
  () => getPosts({ tag: route.params.slug as string, page: page.value, limit: 12 }),
)

if (error.value?.status) {
  throw createError({
    statusCode: error.value?.status ?? 404,
    statusText: `There was an issue fetching the blog category: (${route.params.slug})`,
  })
}

const tag = computed(() =>
  data.value?.posts?.[0]?.tags?.find(({ slug }) => slug === route.params.slug),
)

setI18nParams({
  en: { slug: locale.value !== 'en' ? t(`tags.${route.params.slug}`) : route.params.slug },
  fr: { slug: locale.value !== 'fr' ? t(`tags.${route.params.slug}`) : route.params.slug },
})

useSeoHeadTags({
  title: computed(() => tag.value?.meta_title || tag.value?.name || ''),
  description: computed(() => tag.value?.meta_description || ''),
})
</script>

<i18n src="~~/i18n/locales/common/blog.json" lang="json" />

<i18n src="~~/i18n/locales/common/pages/blog.json" lang="json" />
